
import toast from '../../_lib/simple-notify';
export default class DeleteItemComponent extends HTMLElement {

    

    constructor() {
        super();
       
    }

    private handleOpenForm () {
        
        
    }

    connectedCallback() {
     
    }
    private handleDeletedItem = () => {
        const deleteForm = document.querySelector('form#delete-list-form') as HTMLFormElement;

        let data = new FormData(deleteForm);

        fetch('/', {
            method: 'post',
            body: data,
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
        }).then(response => response.json())
        .then(data => {
            if (data.success) {
                
                toast({
                    title: 'List Deleted',
                    status: 'success',
                });
               
            }else {
                toast({
                    title: 'Failed to List Deleted',
                    status: 'success',
                });
            }
            
        });

    }
    

   
  
}